export default __webpack_public_path__ + "static/media/calibri.82e3b164.ttf";